import TagManager from 'react-gtm-module';

/**
 * @author Jayant
 * @date 21/05/2025
 * @description : Initialize google tag manager(GTM) by checking "googleTagManager" key in bot details and then initializing with google tag manager id(gtmId)
 * @param botData : object - Bot details
 */
export const initializeGTM = (botData: any) => {
  // Check if "googleTagManager" key is present in the bot details
  if (
    botData.configuration && 
    botData.configuration.generalSettings && 
    botData.configuration.generalSettings.googleTagManager && 
    botData.configuration.generalSettings.googleTagManager.headTag.length
  ) {
    let headTag = botData.configuration.generalSettings.googleTagManager.headTag;
    
    // extract the GTM id
    let gtmId = headTag.match(/GTM-\w+/g);

    if (gtmId) {
      const tagManagerArgs = {
        gtmId: gtmId[0]
      };

      TagManager.initialize(tagManagerArgs);
    };
  };
}